import { createAsyncTypes } from 'utils/ActionCreator'

export const TAGS_REQUEST_ASYNC = createAsyncTypes(
  'TAGS_REQUEST_ASYNC',
  'ResolutionCenter/TagsClassification'
)
export const EDIT_TAGS_REQUEST_ASYNC = createAsyncTypes(
  'EDIT_TAGS_REQUEST_ASYNC',
  'ResolutionCenter/TagsClassification'
)
